import React from 'react'
import classnames from 'classnames'
import { Link, withRouter } from 'react-router-dom'
import { getStepByIndex, getStepProgress } from '../../helpers/steps'
import { getConfiguration } from '../../helpers/configuration'
const isStepDisabled = step => step.disabled

const VUStepper = ({ location }) => {
  const currentStep = getStepProgress().findIndex(
    step => step.url === location.pathname
  )

  return (
    <div className="stepBlock">
      <h2 className="stepBlock__title">Your enrolment</h2>

      <div className="stepContainer">
        {getStepProgress()
          .filter(
            ({ url }) => url !== getConfiguration('baseUrl') + '/thankyou'
          )
          .map((step, stepIndex) => {
            const disabled = isStepDisabled(step)
            if (disabled) {
              return (
                <span
                  key={stepIndex}
                  className={classnames(
                    'stepButton',
                    { first: stepIndex === 0 },
                    { last: stepIndex === getStepProgress().length - 1 },
                    { current: stepIndex === currentStep },
                    { submitted: step.submitted },
                    'disabled'
                  )}
                >
                  <span>{step.header}</span>
                </span>
              )
            }
            return (
              <Link
                key={stepIndex}
                className={classnames(
                  'stepButton',
                  { first: stepIndex === 0 },
                  { last: stepIndex === getStepProgress().length - 1 },
                  { current: stepIndex === currentStep },
                  { submitted: step.submitted },
                  'active'
                )}
                to={step.url}
              >
                <span>{step.header}</span>
              </Link>
            )
          })}
      </div>

      <div className="headerBox">
        <div className="header-container">
          <h1>{getStepByIndex(currentStep).header}</h1>
        </div>
      </div>
    </div>
  )
}

export default withRouter(VUStepper)
